import { useState } from "react";
import BookIcon from "../../icons/BookIcon";
import CertificateIcon from "../../icons/CertificateIcon";
import DashboardIcon from "../../icons/DashboardIcon";
import MappingIcon from "../../icons/MappingIcon";
import classes from "./SideBar.module.css";
import { IoChevronDownSharp, IoChevronForward } from "react-icons/io5";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext"; // Adjust this path as needed
import UserListIcon from "../../icons/UserListIcon";
import FileIcon from "../../icons/FileIcon";

const commonNav = [
  {
    icon: <DashboardIcon />,
    name: "Dashboard",
    link: "/dashboard",
  },
];

const laboratoryNav = [
  ...commonNav,
  {
    icon: <MappingIcon />,
    name: "Laboratory mapping",
    link: "",
    sublinks: [
      { name: "Profile", link: "/laboratory-mapping/profile" },
      {
        name: "Laboratory infrastructure",
        link: "/laboratory-mapping/infrastructure",
      },
      { name: "Weekly report", link: "/laboratory-mapping/weekly-report" },
      { name: "Communications & reports", link: "/laboratory-mapping/reports" },
      {
        name: "Specimen referral",
        link: "/laboratory-mapping/specimen-referral",
      },
      {
        name: "Biosafety & biosecurity",
        link: "/laboratory-mapping/biosafety",
      },
      {
        name: "Logistics & supply chain management",
        link: "/laboratory-mapping/logistics",
      },
      { name: "Quality management system", link: "/laboratory-mapping/qms" },
    ],
  },
  {
    icon: <CertificateIcon />,
    name: "Certification",
    link: "",
    innerLinks: [
      {
        name: "SLIPTA checklist",
        link: `/certification/slipta/audit-summary`,
        sublink: [
          {
            name: "Audit summary",
            link: "/certification/slipta/audit-summary",
          },
          {
            name: "Documents & records",
            link: "/certification/slipta/documents",
          },
          {
            name: "Organization & leadership",
            link: "/certification/slipta/leadership",
          },
          {
            name: "Personnel management",
            link: "/certification/slipta/personnel",
          },
          {
            name: "Customer focus",
            link: "/certification/slipta/customer-focus",
          },
          {
            name: "Equipment management",
            link: "/certification/slipta/equipment",
          },
          {
            name: "Inventory management",
            link: "/certification/slipta/inventory",
          },
          { name: "Process management", link: "/certification/slipta/process" },
          {
            name: "Information management",
            link: "/certification/slipta/information",
          },
          {
            name: "Non conforming events",
            link: "/certification/slipta/non-conformities",
          },
          {
            name: "Continual improvement",
            link: "/certification/slipta/improvement",
          },
          {
            name: "Facilities & safety",
            link: "/certification/slipta/facilities-safety",
          },
        ],
      },
    ],
  },
];

const assessorNav = [
  ...commonNav,
  {
    icon: <BookIcon />,
    name: "Accreditation",
    link: "",
    sublinks: [
      { name: "SADCAS F134 - A", link: "/accreditation/sadcas-f134-a" },
      { name: "SADCAS F134 - B", link: "/accreditation/sadcas-f134-b" },
    ],
  },
];

const ministryNav = [
  ...laboratoryNav,
  ...assessorNav, // ministry sees both
];

const ownerNav = [
  ...laboratoryNav,
  ...assessorNav, // owner also sees everything
];

const navList = [
  {
    icon: <DashboardIcon />,
    name: "Dashboard",
    link: "/dashboard",
  },
  {
    icon: <MappingIcon />,
    name: "Laboratory mapping",
    link: "",
    sublinks: [
      { name: "Profile", link: "/laboratory-mapping/profile" },
      {
        name: "Laboratory infrastructure",
        link: "/laboratory-mapping/infrastructure",
      },
      { name: "Weekly report", link: "/laboratory-mapping/weekly-report" },
      { name: "Communications & reports", link: "/laboratory-mapping/reports" },
      {
        name: "Specimen referral",
        link: "/laboratory-mapping/specimen-referral",
      },
      {
        name: "Biosafety & biosecurity",
        link: "/laboratory-mapping/biosafety",
      },
      {
        name: "Logistics & supply chain management",
        link: "/laboratory-mapping/logistics",
      },
      { name: "Quality management system", link: "/laboratory-mapping/qms" },
    ],
  },
  {
    icon: <CertificateIcon />,
    name: "Certification",
    link: "",
    sublinks: [
      {
        name: "SLIPTA checklist",
        link: "/certification/slipta",
        // sublink: [
        //   { name: "Audit summary", link: "/certification/slipta/audit-summary" },
        //   { name: "Documents & records", link: "/certification/slipta/documents" },
        //   { name: "Organization & leadership", link: "/certification/slipta/leadership" },
        //   { name: "Personnel management", link: "/certification/slipta/personnel" },
        //   { name: "Customer focus", link: "/certification/slipta/customer-focus" },
        //   { name: "Equipment management", link: "/certification/slipta/equipment" },
        //   { name: "Inventory management", link: "/certification/slipta/inventory" },
        //   { name: "Process management", link: "/certification/slipta/process" },
        //   { name: "Information management", link: "/certification/slipta/information" },
        //   { name: "Non conforming events", link: "/certification/slipta/non-conformities" },
        //   { name: "Continual improvement", link: "/certification/slipta/improvement" },
        //   { name: "Facilities & safety", link: "/certification/slipta/facilities-safety" },
        // ],
      },
    ],
  },
  {
    icon: <BookIcon />,
    name: "Accreditation",
    link: "",
    sublinks: [
      { name: "SADCAS F134 - A", link: "/accreditation/sadcas-f134-a" },
      { name: "SADCAS F134 - B", link: "/accreditation/sadcas-f134-b" },
    ],
  },
];

const SubLink = ({ links }) => (
  <div className={`${classes.sublinksContainer} d-flex flex-column gap-2`}>
    {links.map((link, i) => (
      <NavLink
        to={link.link}
        key={i}
        className={({ isActive }) =>
          `${classes.sublink} ${isActive ? classes.activeSublink : ""}`
        }
      >
        {link.name}
      </NavLink>
    ))}
  </div>
);

const SideBar = () => {
  const [openSections, setOpenSections] = useState({});
  const { user } = useAuth();
  const userRole = user?.role;
  const labId = user?.labId; // ✅ grab labId here

  // Build laboratory nav dynamically so labId can be injected into links
  const laboratoryNav = [
    ...commonNav,
    {
      icon: <MappingIcon />,
      name: "Laboratory mapping",
      link: "",
      sublinks: [
        { name: "Profile", link: "/laboratory-mapping/profile" },
        {
          name: "Laboratory infrastructure",
          link: "/laboratory-mapping/infrastructure",
        },
        { name: "Weekly report", link: "/laboratory-mapping/weekly-report" },
        {
          name: "Communications & reports",
          link: "/laboratory-mapping/reports",
        },
        {
          name: "Specimen referral",
          link: "/laboratory-mapping/specimen-referral",
        },
        {
          name: "Biosafety & biosecurity",
          link: "/laboratory-mapping/biosafety",
        },
        {
          name: "Logistics & supply chain management",
          link: "/laboratory-mapping/logistics",
        },
        { name: "Quality management system", link: "/laboratory-mapping/qms" },
      ],
    },
    {
      icon: <CertificateIcon />,
      name: "Certification",
      link: "",
      innerLinks: [
        {
          name: "SLIPTA checklist",
          link: "",
          sublink: [
            {
              name: "Download Report",
              link: `/certification/slipta/${labId}/download-report`,
            },
          ],
        },
      ],
    },
    {
      icon: <BookIcon />,
      name: "Accreditation",
      link: "",
      innerLinks: [
        {
          name: "SADCAS F134 - A",
          link: "",
          sublink: [
            {
              name: "Download Report",
              link: `/accreditation/SADCAS F134-A/${labId}/download-report`,
            },
          ],
        },
        {
          name: "SADCAS F134 - B",
          link: "",
          sublink: [
            {
              name: "Download Report",
              link: `/accreditation/SADCAS F134-B/${labId}/download-report`,
            },
          ],
        },
      ],
    },
  ];

  // ✅ HEALTH CENTER nav (only Weekly Report)
  const healthCenterNav = [
    {
      icon: <MappingIcon />,
      name: "Profile",
      link: "/laboratory-mapping/profile",
    },
     {
      icon: <FileIcon small/>,
      name: "Weekly report",
      link: "/laboratory-mapping/weekly-report",
    },
  ];

  const assessorNav = [
    ...commonNav,
    {
      icon: <MappingIcon />,
      name: "Laboratory mapping",
      link: "",
      sublinks: [{ name: "Labs", link: "/laboratory-mapping/labs" }],
    },
    {
      icon: <CertificateIcon />,
      name: "Certification",
      link: "",
      sublinks: [{ name: "SLIPTA checklist", link: "/certification/slipta" }],
    },
    {
      icon: <BookIcon />,
      name: "Accreditation",
      link: "",
      sublinks: [
        { name: "SADCAS F134 - A", link: "/accreditation/sadcas-f134-a" },
        { name: "SADCAS F134 - B", link: "/accreditation/sadcas-f134-b" },
      ],
    },
  ];

  const ministryNav = [
    ...commonNav,
    {
      icon: <MappingIcon />,
      name: "Laboratory mapping",
      link: "",
      sublinks: [{ name: "Labs", link: "/laboratory-mapping/labs" }],
    },
    {
      icon: <UserListIcon />,
      name: "Members",
      link: "/members",
    },
  ];
  const ownerNav = [
    ...assessorNav,
    {
      icon: <UserListIcon />,
      name: "Members",
      link: "/members",
    },
  ];

  let navList = [];
  switch (userRole) {
    case "LABORATORY":
      navList = laboratoryNav;
      break;
    case "ASSESSOR":
      navList = assessorNav;
      break;
    case "MINISTRY":
      navList = ministryNav;
      break;
    case "OWNER":
      navList = ownerNav;
      break;
    case "HEALTH CENTER": // ✅ Only weekly report
      navList = healthCenterNav;
      break;
    default:
      navList = [];
  }

  const toggleSection = (section) => {
    setOpenSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  return (
    <div className={`${classes.wrapper}`}>
      <div className="d-flex flex-column">
        {navList.map((item, i) => {
          const isOuterOpen = openSections[item.name];

          return (
            <div className={`${classes.navItem}`} key={i}>
              {item.link ? (
                <NavLink
                  to={item.link}
                  className={({ isActive }) =>
                    `d-flex align-items-center justify-content-between gap-2 ${
                      classes.navLink
                    } ${isActive ? classes.activeSublink : ""}`
                  }
                >
                  <div className="d-flex align-items-center gap-2">
                    {item.icon} <p>{item.name}</p>
                  </div>
                </NavLink>
              ) : (
                <div
                  className={`d-flex align-items-center justify-content-between gap-2 ${classes.navLink}`}
                  role="button"
                  onClick={() => toggleSection(item.name)}
                >
                  <div className="d-flex align-items-center gap-2">
                    {item.icon} <p>{item.name}</p>
                  </div>
                  {item.sublinks || item.innerLinks ? (
                    isOuterOpen ? (
                      <IoChevronDownSharp />
                    ) : (
                      <IoChevronForward />
                    )
                  ) : null}
                </div>
              )}

              {isOuterOpen && item.sublinks && (
                <SubLink links={item.sublinks} />
              )}

              {isOuterOpen &&
                item.innerLinks &&
                item.innerLinks.map((innerLink, j) => {
                  const isInnerOpen = openSections[innerLink.name];

                  return (
                    <div key={j} className={`${classes.innerLink}`}>
                      {/* <div className="d-flex align-items-center justify-content-between gap-2"> */}
                      <NavLink
                        to={innerLink.link || "#"}
                        className={({ isActive }) =>
                          `flex-grow-1 d-flex align-items-center justify-content-between gap-2 ${
                            classes.navLink
                          } ${
                            isActive && innerLink.link !== ""
                              ? classes.activeSublink
                              : ""
                          }`
                        }
                        onClick={() => toggleSection(innerLink.name)}
                      >
                        {innerLink.name}

                        {innerLink.sublink && (
                          <div role="button" className="px-1">
                            {isInnerOpen ? (
                              <IoChevronDownSharp />
                            ) : (
                              <IoChevronForward />
                            )}
                          </div>
                        )}
                      </NavLink>
                      {/* </div> */}

                      {isInnerOpen && innerLink.sublink && (
                        <SubLink links={innerLink.sublink} />
                      )}
                    </div>
                  );
                })}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SideBar;
